/** @format */

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UtilityService } from "../../utility/utility.service";
import { environmentProd } from "src/environments/environment.prod";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  getProdOrDevUrl: boolean | undefined;
  requestOptions: {} | undefined;
  headers: {} | undefined;
  private GET_DASHBOARD_URL: string | undefined;
  private GET_PRODUCT_SEARCH_URL: string | undefined;
  private GET_PRODUCT_MATERIAL_MDM_URL: string | undefined;
  private GET_DASHLET_URL: string | undefined;

  constructor(
    private httpClient: HttpClient,
    private utility: UtilityService,
  ) {
    const isProd = this.utility.getProdOrDevUrl();
    let urlTobe = isProd
      ? environmentProd.api_base_url
      : environment.api_base_url;

    this.GET_DASHBOARD_URL = urlTobe + 'pre-login/getDashboard/v1/';
    this.GET_PRODUCT_SEARCH_URL = urlTobe + 'post-login/geoloc/v1/';
    this.GET_PRODUCT_MATERIAL_MDM_URL = urlTobe + 'post-login/MdmMaterialsMasterList/v1/';
    this.GET_DASHLET_URL = urlTobe + 'pre-login/getFeatureList/v1/';
  }

  getDashboardData(credentials: any): Observable<any> {
    const apiVersion = this.utility.getApiVersion(this.GET_DASHLET_URL);
    this.requestOptions = this.utility.getHeader(credentials, apiVersion);
    return this.httpClient.get<any>(
      this.GET_DASHBOARD_URL + credentials,
      this.requestOptions,
    );
  }

  getProductSearch_API(credentials: any): Observable<any> {
    const apiVersion = this.utility.getApiVersion(this.GET_PRODUCT_SEARCH_URL);
    this.requestOptions = this.utility.getHeader(credentials, apiVersion);
    return this.httpClient.post<any>(
      this.GET_PRODUCT_SEARCH_URL + encodeURIComponent(credentials),
      {},
      this.requestOptions,
    );
  }

  getProductMaterialMDM_API(credentials: any): Observable<any> {
    const apiVersion = this.utility.getApiVersion(this.GET_PRODUCT_MATERIAL_MDM_URL);
    this.requestOptions = this.utility.getHeader(credentials, apiVersion);
    return this.httpClient.post<any>(
      this.GET_PRODUCT_MATERIAL_MDM_URL + encodeURIComponent(credentials),
      {},
      this.requestOptions,
    );
  }

  getDashletList_API(credentials: any): Observable<any> {
    const apiVersion = this.utility.getApiVersion(this.GET_DASHLET_URL);
    this.requestOptions = this.utility.getHeader(credentials, apiVersion);
    return this.httpClient.get<any>(
      this.GET_DASHLET_URL + encodeURIComponent(credentials),
      this.requestOptions,
    );
  }
}
